import React  from "react"
import tickMark from "../../assets/icons/confirmation-tick.svg";
import { ConfirmationMessage,ConfirmationMessageWrap,ConfirmationMessageImage } from "./styles";



const Message = ({show,children})=>{

    return  (
        show?
        <ConfirmationMessageWrap>
        <ConfirmationMessageImage data-test="confirmation-tick" src={tickMark} alt="Confirmation Tick" />
        <ConfirmationMessage>
            {children}
        </ConfirmationMessage>
      </ConfirmationMessageWrap>
      :null
    )
}

export default Message

